const MS4s = () => {
  const MS4sData = [
    {
      agency: 'Arapahoe County',
      total_construction_sites: '62',
      construction_inspections_count: '813',
      construction_site_enforcement_actions: '21<sup>1</sup>',
      permanent_bmps_count: '67<sup>2</sup>',
      new_permanent_bmps_count: '3',
      inspections: '41<sup>3</sup>',
      flood_control_facilities: '',
    },
    {
      agency: 'Douglas County',
      total_construction_sites: '1256',
      construction_inspections_count: '5973',
      construction_site_enforcement_actions: '140<sup>4</sup>',
      permanent_bmps_count: '180',
      new_permanent_bmps_count: '6',
      inspections: '54',
      flood_control_facilities: '0',
    },
    {
      agency: 'City of Aurora',
      total_construction_sites: '65',
      construction_inspections_count: '308',
      construction_site_enforcement_actions: '8',
      permanent_bmps_count: '29',
      new_permanent_bmps_count: '0',
      inspections: '16',
      flood_control_facilities: '16',
    },
    {
      agency: 'SEMSWA (City of Centennial)',
      total_construction_sites: '98',
      construction_inspections_count: '1272',
      construction_site_enforcement_actions: '61<sup>1</sup>',
      permanent_bmps_count: '107<sup>2</sup>',
      new_permanent_bmps_count: '3',
      inspections: '48<sup>3</sup>',
      flood_control_facilities: '',
    },
    {
      agency: 'City of Greenwood Village',
      total_construction_sites: '3<sup>5</sup>',
      construction_inspections_count: '2',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '29',
      new_permanent_bmps_count: '0<sup>6</sup>',
      inspections: '0<sup>7</sup>',
      flood_control_facilities: '0',
    },
    {
      agency: 'City of Lone Tree',
      total_construction_sites: '13',
      construction_inspections_count: '126',
      construction_site_enforcement_actions: '1',
      permanent_bmps_count: '20',
      new_permanent_bmps_count: '1',
      inspections: '27',
      flood_control_facilities: '0',
    },
    {
      agency: 'City of Castle Pines',
      total_construction_sites: '48',
      construction_inspections_count: '604',
      construction_site_enforcement_actions: '34',
      permanent_bmps_count: '21<sup>8</sup>',
      new_permanent_bmps_count: '4<sup>9</sup>',
      inspections: '41',
      flood_control_facilities: '0',
    },
    {
      agency: 'Town of Castle Rock',
      total_construction_sites: '796',
      construction_inspections_count: '2488',
      construction_site_enforcement_actions: '1539<sup>11</sup>',
      permanent_bmps_count: '134',
      new_permanent_bmps_count: '12',
      inspections: '241',
      flood_control_facilities: '180<sup>12</sup>',
    },
    {
      agency: 'Town of Parker',
      total_construction_sites: '85',
      construction_inspections_count: '2137',
      construction_site_enforcement_actions: '6',
      permanent_bmps_count: '183',
      new_permanent_bmps_count: '4',
      inspections: '409',
      flood_control_facilities: '384<sup>13</sup>',
    },
    {
      agency: 'CDOT',
      total_construction_sites: '3',
      construction_inspections_count: '24',
      construction_site_enforcement_actions: '0',
      permanent_bmps_count: '53',
      new_permanent_bmps_count: '0',
      inspections: '27<sup>14</sup>',
      flood_control_facilities: '0',
    },
  ];

  // Declare and configure request overview table
  const MS4sTable = new requestTable({
    container: '#ms4s-table',
    filterEnabled: false,
    tableHeaders: {
      agency: 'Agency',
      total_construction_sites: 'Total Construction Sites',
      construction_inspections_count: 'Construction Inspections',
      construction_site_enforcement_actions: 'Construction Site Enforcement Actions',
      permanent_bmps_count: 'Permanent BMPs',
      new_permanent_bmps_count: 'New Permanent BMPs',
      inspections: 'Inspections',
      flood_control_facilities: 'Flood Control Facilities',
    },
    tableActions: [],
    tableData: MS4sData,
  });
  MS4sTable.buildTable();
};
